import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import { Icon } from '../../../icon';
import { Button } from '../../../button';
export const StyledHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${getSizeBy(11)};
  padding: ${getSizeBy(2)} ${getSizeBy(3)};
  border-bottom: 1px solid ${getColorShade('onSurface', 'outline')};
`;
export const CheckedIcon = styled(Icon).attrs({ name: 'check', size: 'small' }) `
  & path {
    fill: ${getColor('primary')};
  }
`;
export const HeaderButton = styled(Button).attrs({ variant: 'transparent' }) `
  padding-right: 0;
`;
export const MenuContent = styled.div `
  max-height: 100vh;
  overflow-y: auto;
`;
